import { render, staticRenderFns } from "./DashLayout.vue?vue&type=template&id=9d8e0e52&scoped=true&"
import script from "./DashLayout.vue?vue&type=script&lang=js&"
export * from "./DashLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashLayout.vue?vue&type=style&index=0&id=9d8e0e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8e0e52",
  null
  
)

export default component.exports